import { Col, Row,Button,Upload, Divider, List,Typography, Avatar  } from "antd";
import type { UploadProps } from 'antd';
import {UploadOutlined,FileAddFilled,DeleteFilled,WarningFilled,DiffFilled,DownloadOutlined  } from '@ant-design/icons';
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import {  getAnSpecificMachineDocumentFile, getMachineDocumentFile, getMachineList, getMachineNote, InsertMachineDefination, InsertMachineDocumentFile, updateMachineDefination } from "../../api/api";
import FormContainer from "../../components/FormContainer/FormContainer";
import CustomSelect from "../../components/_common/CustomSelect";
import CustomTextArea from "../../components/_common/CustomTextArea";
import Input from "../../components/_common/Input";
import { useAppDispatch, useAppSelector } from "../../redux/store/storehooks";
import { errorNotify, errorNotifyByErrorObject, sucessNotify } from "../../services/toast.notification";
import { ValidationErrorSpan } from "../../styles/global";
import { useForm } from "../../utility/useForm";
import { validateMachineDefinitionForm } from "../../utility/validationRules";
import { connectionType, installationType } from "../../constants";
import { DocumentContainer, StyledContainer, UploadContainer } from "./styles";
import { NewMachineInstallationHintDialog } from "./NewMachineInstallationHintDialog";




const MachineDefinition = () => {

    let { machineId } = useParams();
    const { values, errors, handleChange, handleSubmit,setErrors,setValues } = useForm(validateMachineDefinitionForm) as any
    const [isLoading,setIsLoading] = useState(true);
    const [isSubmiting,setIsSubmiting] = useState(false);
    const [error,setError] = useState('');
    const [noteList,setNoteList] = useState<any>([]);
    const [documentList,setDocumentList] = useState<any>([]);
    const [showAddNoteDialog,setShowAddNoteDialog] = useState(false);
    const [showAddNotePayload,setShowAddNotePayload] = useState({machineId:0});

    const myStore = useAppSelector((state) => state)
    const dispatch = useAppDispatch();
    const navigate = useNavigate();

    useEffect(()=>{
       
        console.log('useEffect');

        if (machineId !== undefined){
            loadMachines();
            loadMachineNotes();
            loadMachineFiles();
        } 
        else{
            ChooseMachine();
        }

    },[])


    const loadMachines = () => {

        console.log('loadMachines');

        getMachineList(Number(machineId))
        .then((result:any) => {
            ChooseMachine(result.data.data[0]);
        })
        .catch((error) => {
          console.log(error);
          errorNotifyByErrorObject(error,undefined,5000)
          setError('کد ماشین معتبر نیست');
        })

    }

    const ChooseMachine = (data?:any) => {

        if ( machineId !== undefined){
            setValues((values:any) => ({
                ...values,
                name:data.str_MachineName,
                machineCode:data.str_MachineCode,
                base64Driver:data.str_DriverBase64,
                installationType:data.int_InstallationType,
                connectionType:data.int_ConnectionType,
                description:data.str_Description,
                hasDriver:data.hasDriver
              }));
        }
        else
        {
            setValues((values:any) => ({
                ...values,
                name:"",
                machineCode:"",
                base64Driver:"",
                installationType:0,
                connectionType:0,
                description:"",
                hasDriver:false
              }));

        }

        setIsLoading(false);

    }

    const loadMachineNotes = () => {

        console.log('loadMachineNotes');

        getMachineNote(Number(machineId))
        .then((result:any) => {
            console.log(result.data.data)
            setNoteList(result.data.data)
        })
        .catch((error) => {
          console.log(error);
          errorNotifyByErrorObject(error,undefined,5000)
          setError('کد ماشین معتبر نیست');
        })

    }

    const loadMachineFiles = () => {
    

        getMachineDocumentFile(Number(machineId))
        .then((result:any) => {
            console.log(result.data.data)
            setDocumentList(result.data.data)
        })
        .catch((error) => {
          console.log(error);
          errorNotifyByErrorObject(error,undefined,5000)
          setError('کد ماشین معتبر نیست');
        })

    }

    const AddNewNote = () => {

        setShowAddNoteDialog(true);
        
        setShowAddNotePayload((values:any) => ({
            ...values,
            machineId,
          }));

    }

    const AddNewFile = (base64File:string,fileName:string,fileExtension:string) => {

        InsertMachineDocumentFile(
            Number(machineId),
            myStore.auth.userId || 0,
            base64File,
            fileName,
            fileExtension
        )
        .then((result:any) => {
            sucessNotify("اطلاعات با موفقیت ذخیره شده",undefined,5000)
            loadMachineFiles();
        })
        .catch((error) => {
          console.log(error);
          errorNotify(error.response.data.errorMessage,undefined,5000)
        })

    }

    const inActiveFunctionPrompt = () => {

       errorNotify("این گزینه در حال حاضر غیر فعال می باشد")

    }

    const downloadDocument = (item:any) => {

        console.log(item);

        getAnSpecificMachineDocumentFile(item.machineFileId)
        .then((result:any) => {
            console.log(result.data.data);
            if (result.data.data != undefined && result.data.data != null){

                const downloadLink = document.createElement("a");       
                downloadLink.href = result.data.data;
                downloadLink.download = item.str_fileName;
                downloadLink.click();

                sucessNotify("فایل آموزشی دانلود شد",undefined,3000);

            }
            else{
                errorNotify("فایل آموزشی جهت دانلود یافت نشد",undefined,5000);
            } 

        })
        .catch((error) => {
          console.log(error);
          errorNotifyByErrorObject(error,undefined,5000)
        })
     } 

    const uploadDLL: UploadProps = {
        action: '',
        listType: 'text',
        beforeUpload(file) {
          console.log(file);
          return new Promise(resolve => {
            const reader = new FileReader();
            reader.readAsDataURL(file);

            reader.onload = function () {
                console.log(reader.result)

                if (reader.result){

                    setValues((values:any) => ({
                        ...values,
                        ["base64Driver"]: reader.result?.toString().replace('data:application/x-msdownload;base64,',''),
                        ["hasDriver"]: true,
                      }));

                }
            };
            reader.onerror = function (error) {
                console.log('Error: ', error);
                errorNotify("خطا در بارگذاری فایل",undefined,5000)
            };
          });
        },
    };

    const uploadDocumentFile: UploadProps = {
        action: '',
        listType: 'text',
        beforeUpload(file) {
          console.log(file);
          return new Promise(resolve => {
            const reader = new FileReader();
            reader.readAsDataURL(file);

            reader.onload = function () {
                console.log(reader.result)

                if (reader.result){

                    AddNewFile(
                        reader.result?.toString(),
                        file.name,
                        file.type
                    )

                }
            };
            reader.onerror = function (error) {
                console.log('Error: ', error);
                errorNotify("خطا در بارگذاری فایل",undefined,5000)
            };
          });
        },
    };

    const ValidationType = ({ type }: any) => {
        const ErrorMessage = errors[type]; 
        return (
            <ValidationErrorSpan erros={errors[type]}>{ErrorMessage}</ValidationErrorSpan>
        );
    };

    const FormSubmit = (e:any) => {

        e.preventDefault();
        
        console.log(values);

        let error= validateMachineDefinitionForm(values);
        if (Object.keys(error).length == 0)
        {

            if (machineId === undefined)
            {

                setIsSubmiting(true)

                InsertMachineDefination(
                    values.name,
                    values.machineCode,
                    values.base64Driver,
                    Number(values.installationType),
                    Number(values.connectionType),
                    values.description ? values.description : ""
                )
                .then((result:any) => {
                    console.log(result);
                    setIsSubmiting(false)
                    navigate("/parsicuser/machine");
                    sucessNotify("ثبت با موفقیت انجام شد")
                })
                .catch((error) => {
                    setIsSubmiting(false)
                    errorNotify(error.response.data.errorMessage,undefined,5000)
                })

            }
            else
            {

                setIsSubmiting(true)

                updateMachineDefination(
                    Number(machineId),
                    values.name,
                    values.machineCode,
                    values.base64Driver,
                    Number(values.installationType),
                    Number(values.connectionType),
                    values.description ? values.description : ""
                )
                .then((result:any) => {
                    console.log(result);
                    setIsSubmiting(false)
                    navigate("/parsicuser/machine");
                    sucessNotify("ثبت با موفقیت انجام شد")
                })
                .catch((error) => {
                    setIsSubmiting(false)
                    errorNotify(error.response.data.errorMessage,undefined,5000)
                })

            }



        }
        else
        {
          setErrors(error);
        }
        
    }


    return(
        <StyledContainer>

           <FormContainer title={machineId===undefined ? "تعریف دستگاه جدید" : "ویرایش دستگاه"} onSubmit={FormSubmit} isLoading={isLoading} isSubmiting = {isSubmiting}> 
                  
                    <Divider plain>عمومی</Divider>

                    <Row>

                        <Col lg={8} md={8} sm={12} xs={24}>
                            <Input
                                type="text"
                                name="machineCode"
                                placeholder="کد داخلی"
                                value={values.machineCode}
                                onChange={handleChange}
                            />
                            <ValidationType type="machineCode" />
                        </Col>

                        <Col lg={8} md={8} sm={12} xs={24}>
                            <Input
                                type="text"
                                name="name"
                                placeholder="نام کامل"
                                value={values.name}
                                onChange={handleChange}
                            />
                            <ValidationType type="name" />
                        </Col>

                        <Col lg={8} md={8} sm={12} xs={24}>
                            <CustomSelect
                                name="installationType"
                                placeholder="نوع نصب"
                                itemList={installationType}
                                value={values.installationType}
                                onChange={handleChange}
                                valueObjectField={"id"}
                                displayObjectField={"title"}
                            />
                            <ValidationType type="installationType" />
                        </Col>
                    </Row>

                    <Row>
                        <Col lg={8} md={8} sm={12} xs={24}>
                            <CustomSelect
                                name="connectionType"
                                placeholder="نوع اتصال"
                                itemList={connectionType}
                                value={values.connectionType}
                                onChange={handleChange}
                                valueObjectField={"id"}
                                displayObjectField={"title"}
                            />
                            <ValidationType type="connectionType" />
                        </Col>
                        <Col lg={8} md={8} sm={12} xs={24}>
                            <UploadContainer>
                                <Input
                                    type="text"
                                    name="hasDriver"
                                    placeholder="درایور"
                                    value={values.hasDriver ? "آپلود شده هست" : "منتظر آپلود درایور"}
                                    onChange={(e) => console.log(e)}
                                    disabled={true}
                                />
                                <Upload {...uploadDLL}>
                                    <Button icon={<UploadOutlined/>}></Button>
                                </Upload>
                            </UploadContainer>
                            <ValidationType type="hasDriver" />
                        </Col>
                    </Row>

                    <Row>
                        <Col lg={24} md={24} sm={24} xs={24}>
                            <CustomTextArea
                                name="description"
                                placeholder="توضیحات"
                                value={values.description}
                                onChange={handleChange}
                            />
                            <ValidationType type="description" />
                        </Col>
                    </Row>

                    {machineId !== undefined && (
                        <>                    
                            <Divider plain>مستندات فنی</Divider>

                            <DocumentContainer>
                                <Row>
                                    <Col lg={12} md={12} sm={24} xs={24}>
                                        <List
                                            header={
                                                <Row>
                                                    <Col><DiffFilled  onClick={AddNewNote}  style={{ color: 'Green',fontSize: '18px' }}/></Col>
                                                    <Col lg={23} md={23} sm={23} xs={23}>نکات آموزشی</Col>
                                                </Row>
                                            }
                                            style={{margin: '10px' }}
                                            footer={undefined}
                                            bordered
                                            dataSource={noteList}   
                                            renderItem={(item:any) => (
                                                <List.Item actions={
                                                    [
                                                        <DeleteFilled  onClick={inActiveFunctionPrompt}  style={{ color: 'red',fontSize: '18px' }}/>,
                                                        <WarningFilled  onClick={inActiveFunctionPrompt}  style={{ color: 'orange',fontSize: '18px' }}/>
                                                    ]
                                                }>
                                                    <>
                                                        <List.Item.Meta
                                                            description={item.str_Comment}
                                                        />
                                                    </>
                                                </List.Item>
                                            )}
                                        />
                                    </Col>
                                    <Col lg={12} md={12} sm={24} xs={24}>
                                        <List
                                            header={
                                                <Row>
                                                    <Col>
                                                        <Upload {...uploadDocumentFile}>
                                                            <DiffFilled  style={{ color: 'Green',fontSize: '18px' }}/>
                                                        </Upload>
                                                        
                                                    </Col>
                                                    <Col lg={23} md={23} sm={23} xs={23}>فایل های آموزشی</Col>
                                                </Row>
                                            }
                                            style={{margin: '10px' }}
                                            footer={undefined}
                                            bordered
                                            dataSource={documentList}
                                            renderItem={(item:any) => (
                                                <List.Item actions={
                                                    [
                                                        <DeleteFilled  onClick={inActiveFunctionPrompt}  style={{ color: 'red',fontSize: '18px' }}/>,
                                                        <WarningFilled  onClick={inActiveFunctionPrompt}  style={{ color: 'orange',fontSize: '18px' }}/>,
                                                        <DownloadOutlined   onClick={()=>downloadDocument(item)}  style={{ color: 'blue',fontSize: '18px' }}/>
                                                    ]
                                                }>
                                                    <>
                                                        <List.Item.Meta
                                                            description={item.str_fileName}
                                                        />
                                                    </>
                                                </List.Item>
                                            )}
                                        />
                                    </Col>
                                </Row>
                            </DocumentContainer>
                        </>
                    )}

           </FormContainer>

           <NewMachineInstallationHintDialog
                visible={showAddNoteDialog}
                onSubmit={() => console.log(true)}
                onCancel={() => {setShowAddNoteDialog(false);loadMachineNotes()}}
                payLoad={showAddNotePayload}
                setShowDialog ={() => {setShowAddNoteDialog(false);loadMachineNotes()}}
            />

        </StyledContainer>
    )
}

export default MachineDefinition;